// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Lib$PorterinFusionkitSentry from "../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as GeocodingApi$PorterinFeature from "../geocode/domain/repo/GeocodingApi.mjs";
import * as ErrorConstants$PorterinFeature from "../core/constants/ErrorConstants.mjs";
import * as PlaceDetailsApi$PorterinFeature from "./PlaceDetailsApi.mjs";
import * as GoogleReactAutocompleteHelper$PorterinFeature from "../core/helpers/GoogleReactAutocompleteHelper.mjs";

function useGoogleAutoComplete(mapInst) {
  var retryWithUpdatedPlaceId = function (place_id, form_on_change) {
    var onSuccess = function (id) {
      GeocodingApi$PorterinFeature.getGeocodeFromPlaceId(id, (function (geocode) {
              GoogleReactAutocompleteHelper$PorterinFeature.setGeocodingAddress(geocode, form_on_change);
            }), (function (param) {
              Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, ErrorConstants$PorterinFeature.googleGeoCodeError);
              GoogleReactAutocompleteHelper$PorterinFeature.setDefaultAddress("Try again", form_on_change);
            }));
    };
    var onError = function (_unit) {
      Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, ErrorConstants$PorterinFeature.fetchPlaceIdError);
      GoogleReactAutocompleteHelper$PorterinFeature.setDefaultAddress("Try again", form_on_change);
    };
    var service = new (window.google.maps.places.PlacesService)(mapInst);
    try {
      service.getDetails({
            placeId: place_id,
            fields: ["place_id"]
          }, (function (data) {
              Curry._1(onSuccess, PlaceDetailsApi$PorterinFeature.mapToState(data));
            }));
      return ;
    }
    catch (exn){
      return Curry._1(onError, undefined);
    }
  };
  var getAddressDetailsGeocode = function (place_id, form_on_change) {
    if (place_id === "") {
      return GoogleReactAutocompleteHelper$PorterinFeature.setDefaultAddress("Select from dropdown", form_on_change);
    } else {
      return GeocodingApi$PorterinFeature.getGeocodeFromPlaceId(place_id, (function (geocode) {
                    GoogleReactAutocompleteHelper$PorterinFeature.setGeocodingAddress(geocode, form_on_change);
                  }), (function (_error) {
                    retryWithUpdatedPlaceId(place_id, form_on_change);
                  }));
    }
  };
  var getAddressDetailsPlaceAutocomplete = function (place_id, form_on_change, recorded_address) {
    if (place_id === "") {
      return GoogleReactAutocompleteHelper$PorterinFeature.setDefaultAddress("Select from dropdown", form_on_change);
    } else {
      return GeocodingApi$PorterinFeature.getGeocodeFromPlaceId(place_id, (function (geocode) {
                    Curry._2(form_on_change, {
                          landmark: recorded_address,
                          location: geocode.geometry.location
                        }, {
                          pincode: GoogleReactAutocompleteHelper$PorterinFeature.getAddressTypeDetail(geocode.address_components, "postal_code"),
                          state: GoogleReactAutocompleteHelper$PorterinFeature.getAddressTypeDetail(geocode.address_components, "administrative_area_level_1"),
                          city: GoogleReactAutocompleteHelper$PorterinFeature.getAddressTypeDetail(geocode.address_components, "administrative_area_level_2"),
                          locality: GoogleReactAutocompleteHelper$PorterinFeature.getAddressTypeDetail(geocode.address_components, "sublocality_level_1"),
                          sub_locality: GoogleReactAutocompleteHelper$PorterinFeature.getAddressTypeDetail(geocode.address_components, "sublocality_level_2")
                        });
                  }), (function (_error) {
                    retryWithUpdatedPlaceId(place_id, form_on_change);
                  }));
    }
  };
  return [
          getAddressDetailsPlaceAutocomplete,
          getAddressDetailsGeocode
        ];
}

export {
  useGoogleAutoComplete ,
}
/* Lib-PorterinFusionkitSentry Not a pure module */
